export const langaugeCode = {
    "English" : "en",
    "हिंदी" : "hi",
    "ଓଡ଼ିଆ" : "or"
}

export const languageLabel = {
    "en" : "English",
    "hi" : "हिंदी",
    "or" : "ଓଡ଼ିଆ"
}

export const fontSizeLabel = {
    "en": "A",
    "hi": "आ",
    "or": "A"
}
export const languageCheckSuccessMessage = {
    "en" : " Successfully Logged In",
    "hi" : "लॉग इन सफल रहा",
    "or" : "ଲଗଇନ୍ ସଫଳ ହେଲା"
}
export const languageCheckWelcomeMessage = {
    "en" : "Welcome",
    "hi" : "स्वागत है,",
    "or" : "ସ୍ୱାଗତ,"
}
export const languagecheckHeading = {
    "en" : "Select Language",
    "hi" : "भाषा चुनें",
    "or": "ଭାଷା ଚୟନ କରନ୍ତୁ"
}
export const languagecheckSubHeading = {
    "en" : "Healthvaani is available in these languages",
    "hi" : "हेल्थवाणी इन भाषाओं में उपलब्ध है",
    "or": "Healthvaani ଏହି ଭାଷାଗୁଡିକରେ ଉପଲବ୍ଧ ଅଛି"
}
export const languagecheckNextButton = {
    "en" : "Start Asking Questions",
    "hi" : "प्रश्न पूछना शुरू करें",
    "or" : "ପ୍ରଶ୍ନ ପଚାରିବା ଆରମ୍ଭ କରନ୍ତୁ"
}
export const LanguageName = {
    en: "English",
    hi: "हिंदी",
    or: "ଓଡ଼ିଆ",
    bn: "Bengali",
    ta: "Tamil",
    te: "Telugu",
    mr: "Marathi",
    gu: "Gujarati",
    pa: "Punjabi",
    ml: "Malayam",
    ka: "Kannada",
    ur: "Urdu",
  };